const TOOL_ROUTE_HASH = {
  "quick-sheets": "#quick-sheets",
  "concept-questions": "#concept-questions",
  "question-variations": "#question-variations",
  "quick-assessment": "#quick-assessment",
  "teach-this-topic": "#teach-this-topic",
  "explain-differently": "#explain-differently",
  "content-simplifier": "#content-simplifier",
  "question-paper": "#question-paper",
  "section-builder": "#section-builder",
  "difficulty-balancer": "#difficulty-balancer",
  "doubt-solver": "#doubt-solver",
  "slide-deck-generator": "#slide-deck-generator",
  "project-builder": "#project-builder",
  "activity-generator": "#activity-generator",
  "real-world-task": "#real-world-task",
};

export function resolveToolRouteHash(toolId) {
  return TOOL_ROUTE_HASH[toolId] ?? null;
}
